import { render } from "./scheduleAutoModal.vue?vue&type=template&id=525f2b27&scoped=true"
import script from "./scheduleAutoModal.vue?vue&type=script&lang=js"
export * from "./scheduleAutoModal.vue?vue&type=script&lang=js"

import "./scheduleAutoModal.vue?vue&type=style&index=0&id=525f2b27&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525f2b27"]])

export default __exports__